// The CS2 kill feed: oldest kill on top, each shown 5 s then faded out over 0.8 s (game time).
const TICKS_PER_SECOND = 64;
const SHOWN_TICKS = 5 * TICKS_PER_SECOND;
const FADE_TICKS = 0.8 * TICKS_PER_SECOND;

export function killsInFeed(kills, tick) {
  return (kills || [])
    .filter((kill) => kill.tick < tick && tick - kill.tick < SHOWN_TICKS + FADE_TICKS)
    .sort((a, b) => a.tick - b.tick);
}

export function killOpacity(kill, tick) {
  const fading = tick - kill.tick - SHOWN_TICKS;
  return fading <= 0 ? 1 : Math.max(0, 1 - fading / FADE_TICKS);
}
